module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Panterra Chronicles")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-dual-reality"
    }
  }, [_vm._v("Chapter 1: Dual Reality")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-jackpot-koalas"
    }
  }, [_vm._v("Chapter 2: Jackpot Koalas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-meanwhile-back-at-the-ranch"
    }
  }, [_vm._v("Chapter 3: Meanwhile, Back at\n                the Ranch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-supertramps-rising",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: SuperTramps Rising")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-wildcard-hunt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Wildcard Hunt")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-ghost-town-gully",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Ghost Town Gully")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-entering-a-new-dimension",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Entering a New\n                Dimension")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-quantum-leap",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Quantum Leap")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-menace-of-mortsleam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Menace of\n                Mortsleam")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-game-on",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Game On")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-lavender-spade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Lavender Spade")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-post-divisional-title-win",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Post-Divisional\n                Title Win")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-code-crackers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Code Crackers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-the-panterra-code",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Panterra Code")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-the-collections-of-the-viscount-and-viscountess",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n                15 The Collections of the Viscount and Viscountess")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-way-outback-outpost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Way Outback Outpost")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-drone-crossing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Drone Crossing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-the-final-matchup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Final Matchup")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-beau-dean-visits-his-godfather",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Beau Dean\n                Visits His Godfather")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-the-koalas-take-the-field",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Koalas Take\n                the Field")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-stuck-again-cactus-ridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Stuck Again Cactus\n                Ridge")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-the-battle-of-rainbow-ridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: The Battle of\n                Rainbow Ridge")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0